module.exports = __webpack_public_path__ + "static/media/Orthopedics-Knee Condition Intake-1@3x.89473641.png";